import type { TextProps } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

type FormattedTooltipContentProps = Pick<TextProps, 'weight'> & {
  title: string
  description?: string
  className?: string
}

/**
 * Отформатированный тултип
 */
export const FormattedTooltipContent: FC<FormattedTooltipContentProps> = ({
  title,
  description,
  weight = 'bold',
  className,
}) => {
  return (
    <div className={className}>
      <Text size="xs" weight={weight} view="primary">
        {title}
      </Text>
      {!!description && (
        <Text size="xs" view="primary">
          {description}
        </Text>
      )}
    </div>
  )
}
